export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBT81psRiMumvUIdzN1EAwK8NjKIEYUPM0',
    authDomain: 'dabubble-69d59.firebaseapp.com',
    databaseURL: 'https://dabubble-69d59-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'dabubble-69d59',
    storageBucket: 'dabubble-69d59.firebasestorage.app',
    messagingSenderId: '69214031220',
    appId: '1:69214031220:web:3d2480569252b62ac03021',
  },
  guest: {
    email: 'guest@example.com',
    password: 'guest1234',
    uid: 'ZADXT0hXHmMwluwQFiT9qXCgK8E2'
  }
};